import { FC, useCallback } from 'react'
import { AppraisalContextType } from '../../../modules/appraisal/AppraisalTypes'
import { EvaluationScaleInformation } from '../../../modules/appraisal/evaluation/EvaluationScaleInformation'
import { ScoreGridCategory } from '../../../modules/appraisal/evaluation/ScoreGridCategory.enum'
import { ScoreGoalDto } from '../../../types'
import PerButtonCircle from '../ButtonCircle'
import PerFlexRow from '../FlexRow'
import PerIcon from '../Icon'
import PerSpacer from '../Spacer'
import PerText from '../Text'
import './index.less'

interface Tab {
  title: string
  id: string
}

interface TabBarProps {
  tabs: Tab[]
  active: string
  onTabClicked: (id: ScoreGridCategory) => void
  scoreGoals: ScoreGoalDto[]
  type: AppraisalContextType
}

const TabBar: FC<TabBarProps> = ({ tabs, active, onTabClicked, scoreGoals, type }) => {
  const handleTabClick = (tab: Tab) => {
    onTabClicked(tab.id as ScoreGridCategory)
  }

  const getEvaluationValueByType = (goal: ScoreGoalDto, key: 'employeeEvaluation' | 'reviewerEvaluation' | 'resultEvaluation') => {
    if ('resultEvaluation' === key) return goal.resultEvaluation
    if ('employeeEvaluation' === key) return goal.employeeEvaluation
    if ('reviewerEvaluation' === key) return goal.reviewerEvaluation
    return 0 // fallback
  }
  const resultEvaluationFilled = useCallback(
    (tabId: string) => {
      const tabData = scoreGoals.filter((scoreGoal) => scoreGoal.viewId.includes(tabId))
      const viewType: 'employeeEvaluation' | 'reviewerEvaluation' | 'resultEvaluation' =
        type === 'employee' ? 'employeeEvaluation' : type === 'manager' ? 'reviewerEvaluation' : 'resultEvaluation'
      return tabData.every((goal) => getEvaluationValueByType(goal, viewType))
    },
    [scoreGoals, type],
  )

  return (
    <PerFlexRow direction="row" align="middle" justify="space-between" className="fullWidth">
      <div className="tab-bar">
        {tabs.map((tab) => (
          <div
            className={`tab-bar__tab ${active === tab.id ? 'tab-bar__tab--active' : ''}`}
            onClick={() => handleTabClick(tab)}
            key={tab.id}
            data-e2e-appraisal-evaluation-tab-button={tab.id}
          >
            <PerSpacer ml="m" mr={resultEvaluationFilled(tab.id) ? undefined : 'm'} display="inline">
              <PerText display="inline-block">{tab.title}</PerText>
              {resultEvaluationFilled(tab.id) && (
                <>
                  <PerSpacer mr="xxs" display="inline" />
                  <PerIcon name="check_stroke" color="primary" size={12} />
                </>
              )}
            </PerSpacer>
          </div>
        ))}
      </div>
      <PerButtonCircle
        icon="info_stroke"
        color="secondary"
        variant="pastel"
        tooltip={<EvaluationScaleInformation type={type} />}
        size="small"
      />
    </PerFlexRow>
  )
}

export default TabBar
